export default function description() {
    return (
        <div className="card__description-basic">
            <div className="card__description">
                <p className="card__description-title">
                    Загальна характеристика
                </p>
                <p className="card__description-text">
                    СУМО 007 (НС 6059) — це один із найпродуктивніших гібридів у лінійці SUMO®, який заслужено позиціонується як №1 за рівнем урожайності серед SUMO-гібридів. Він поєднує високий потенціал, стабільність та витривалість, що робить його універсальним рішенням для різних умов вирощування.
                </p>
                <p className="card__description-text">
                    Гібрид відзначається високою посухостійкістю та здатністю формувати стабільний урожай навіть у складних кліматичних умовах.
                </p>
                <p className="card__description-title">Основні переваги</p>
                <ol className="card__description-list">
                    <li className="card__description-numbering">Один із найвищих потенціалів урожайності — до 5,8 т/га</li>
                    <li className="card__description-numbering">№1 серед SUMO-гібридів за продуктивністю</li>
                    <li className="card__description-numbering">Висока посухостійкість</li>
                    <li className="card__description-numbering">Стійкість до вовчка — 6 рас (A–F)</li>
                    <li className="card__description-numbering">Висока стабільність у різних умовах</li>
                    <li className="card__description-numbering">Добре реагує на інтенсивну технологію</li>
                </ol>
                <table className="card__description__table">
                    <tr>
                        <td className="card__description__td">Період вегетації</td>
                        <td className="card__description__th-index">109–114 днів</td>
                    </tr>
                    <tr>
                        <td className="card__description__td">Олійність:</td>
                        <td className="card__description__th-index">50–52%</td>
                    </tr>
                    <tr>
                        <td className="card__description__td card__description__td--link">Висота рослин</td>
                        <td className="card__description__th-index">165–185 см</td>
                    </tr>
                </table>
                <p className="card__description-title">
                    Рекомендації по густоті
                </p>
                <ol className="card__description-list">
                    <li className="card__description-numbering">За достатнього зволоження: 60–65 тис. рослин/га</li>
                    <li className="card__description-numbering">У посушливих умовах: 45–50 тис. рослин/га</li>
                </ol>
                <div className="card__description-title">Стійкість та толерантність</div>
                <ol className="card__description-list">
                    <p className="card__description-text">
                        Стійкість:
                    </p>
                    <li className="card__description-numbering">Посухостійкість, осипання — 9/10</li>
                    <li className="card__description-numbering">Холодостійкість, вилягання — 8/10</li>
                    <p className="card__description-text">
                        Толерантність до хвороб:
                    </p>
                    <li className="card__description-numbering">Іржа, сіра гниль, альтернаріоз — 9/10</li>
                    <li className="card__description-numbering">Фомопсис, фомоз, пероноспороз, біла гниль — 8/10</li>
                    <li className="card__description-numbering">Септоріоз — 7/10</li>
                </ol>
                <div className="card__description-title">Рекомендовані зони вирощування</div>
                <p className="card__description-text">
                    Гібрид рекомендований для вирощування у Степу та Лісостепу України, де максимально реалізує свій потенціал урожайності. Підходить також для більш ризикованих зон за дотримання технології.
                </p>
                <div className="card__description-title">Рекомендації щодо вирощування</div>
                <p className="card__description-text">
                    СУМО 007 добре реагує на інтенсивні технології вирощування, але також демонструє стабільність у посушливих умовах. Рекомендується застосування гербіцидів системи SUMO® (Експрес + ПАР Тренд). Гібрид підходить для господарств, які орієнтовані на максимальний прибуток з гектара.
                </p>
                <p className="card__description-text">
                    СУМО 007 — це вибір для тих, хто хоче максимальний урожай і лідерство по результату. Один із найкращих варіантів для інтенсивного землеробства та отримання високого прибутку.
                </p>
            </div>
            <div className="card__description-preference">
                <div className="aside__title--new">Головні переваги</div>
                <div className="asede__head">
                    <div className="aside__block">Високий потенція урожайності</div>
                    <div className="aside__block">Найкращу віддачу забезпечує на родючих грунтах</div>
                    <div className="aside__block">Один із найбільш високоврожайних гібридів з високим вмістом олії</div>
                </div>
            </div>
        </div>
    );
}
